// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/auth/auth.proto (package ga.config_manager.auth, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/auth/auth.proto.
 */
export const file_ga_config_manager_auth_auth: GenFile = /*@__PURE__*/
  fileDesc("CiFnYS9jb25maWdfbWFuYWdlci9hdXRoL2F1dGgucHJvdG8SFmdhLmNvbmZpZ19tYW5hZ2VyLmF1dGgibgoPUGFzc3dvcmRsZXNzUmVxEg0KBWVtYWlsGAEgASgJEhQKDGNhbGxiYWNrX3VybBgCIAEoCRIfChJhbm90aGVyX3VzZXJfZW1haWwYAyABKAlIAIgBAUIVChNfYW5vdGhlcl91c2VyX2VtYWlsIhIKEFBhc3N3b3JkbGVzc1Jlc3AiJQoURXh0ZXJuYWxMb2dpblJlcXVlc3QSDQoFdG9rZW4YASABKAkiOQoIVXNlclJlc3ASCgoCaWQYASABKAkSDQoFZW1haWwYAyABKAkSEgoKc2Vzc2lvbl9pZBgJIAEoCSILCglMb2dvdXRSZXEiDAoKTG9nb3V0UmVzcDKyAgoLQXV0aFNlcnZpY2USaQoURXh0ZXJuYWxQYXNzd29yZGxlc3MSJy5nYS5jb25maWdfbWFuYWdlci5hdXRoLlBhc3N3b3JkbGVzc1JlcRooLmdhLmNvbmZpZ19tYW5hZ2VyLmF1dGguUGFzc3dvcmRsZXNzUmVzcBJfCg1FeHRlcm5hbExvZ2luEiwuZ2EuY29uZmlnX21hbmFnZXIuYXV0aC5FeHRlcm5hbExvZ2luUmVxdWVzdBogLmdhLmNvbmZpZ19tYW5hZ2VyLmF1dGguVXNlclJlc3ASVwoORXh0ZXJuYWxMb2dvdXQSIS5nYS5jb25maWdfbWFuYWdlci5hdXRoLkxvZ291dFJlcRoiLmdhLmNvbmZpZ19tYW5hZ2VyLmF1dGguTG9nb3V0UmVzcELkAQoaY29tLmdhLmNvbmZpZ19tYW5hZ2VyLmF1dGhCCUF1dGhQcm90b1ABWkV4ZGV2dGVhbS5jb20vYThyL2NvbmZpZy1tYW5hZ2VyL2ludGVybmFsL3Byb3RvL2dhL2NvbmZpZ19tYW5hZ2VyL2F1dGiiAgNHQ0GqAhVHYS5Db25maWdNYW5hZ2VyLkF1dGjKAhVHYVxDb25maWdNYW5hZ2VyXEF1dGjiAiFHYVxDb25maWdNYW5hZ2VyXEF1dGhcR1BCTWV0YWRhdGHqAhdHYTo6Q29uZmlnTWFuYWdlcjo6QXV0aGIGcHJvdG8z");

/**
 * @generated from message ga.config_manager.auth.PasswordlessReq
 */
export type PasswordlessReq = Message<"ga.config_manager.auth.PasswordlessReq"> & {
  /**
   * User email.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * Frontend passwordless callback URL.
   *
   * @generated from field: string callback_url = 2;
   */
  callbackUrl: string;

  /**
   * email of user which permissions will be copied.
   *
   * @generated from field: optional string another_user_email = 3;
   */
  anotherUserEmail?: string;
};

/**
 * Describes the message ga.config_manager.auth.PasswordlessReq.
 * Use `create(PasswordlessReqSchema)` to create a new message.
 */
export const PasswordlessReqSchema: GenMessage<PasswordlessReq> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_auth_auth, 0);

/**
 * @generated from message ga.config_manager.auth.PasswordlessResp
 */
export type PasswordlessResp = Message<"ga.config_manager.auth.PasswordlessResp"> & {
};

/**
 * Describes the message ga.config_manager.auth.PasswordlessResp.
 * Use `create(PasswordlessRespSchema)` to create a new message.
 */
export const PasswordlessRespSchema: GenMessage<PasswordlessResp> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_auth_auth, 1);

/**
 * @generated from message ga.config_manager.auth.ExternalLoginRequest
 */
export type ExternalLoginRequest = Message<"ga.config_manager.auth.ExternalLoginRequest"> & {
  /**
   * bo Token.
   *
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message ga.config_manager.auth.ExternalLoginRequest.
 * Use `create(ExternalLoginRequestSchema)` to create a new message.
 */
export const ExternalLoginRequestSchema: GenMessage<ExternalLoginRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_auth_auth, 2);

/**
 * @generated from message ga.config_manager.auth.UserResp
 */
export type UserResp = Message<"ga.config_manager.auth.UserResp"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   *  string user_type = 2; // Possible values: 'a8r_staff', 'casino_staff', 'game_provider_staff'.
   *
   * User email.
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   *  string company_id = 6;
   *  repeated string team_ids = 7;
   *
   *  optional string another_user_email = 10;
   *
   * @generated from field: string session_id = 9;
   */
  sessionId: string;
};

/**
 * Describes the message ga.config_manager.auth.UserResp.
 * Use `create(UserRespSchema)` to create a new message.
 */
export const UserRespSchema: GenMessage<UserResp> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_auth_auth, 3);

/**
 * @generated from message ga.config_manager.auth.LogoutReq
 */
export type LogoutReq = Message<"ga.config_manager.auth.LogoutReq"> & {
};

/**
 * Describes the message ga.config_manager.auth.LogoutReq.
 * Use `create(LogoutReqSchema)` to create a new message.
 */
export const LogoutReqSchema: GenMessage<LogoutReq> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_auth_auth, 4);

/**
 * @generated from message ga.config_manager.auth.LogoutResp
 */
export type LogoutResp = Message<"ga.config_manager.auth.LogoutResp"> & {
};

/**
 * Describes the message ga.config_manager.auth.LogoutResp.
 * Use `create(LogoutRespSchema)` to create a new message.
 */
export const LogoutRespSchema: GenMessage<LogoutResp> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_auth_auth, 5);

/**
 * @generated from service ga.config_manager.auth.AuthService
 */
export const AuthService: GenService<{
  /**
   * bo
   *
   * header not required
   *
   * @generated from rpc ga.config_manager.auth.AuthService.ExternalPasswordless
   */
  externalPasswordless: {
    methodKind: "unary";
    input: typeof PasswordlessReqSchema;
    output: typeof PasswordlessRespSchema;
  },
  /**
   * header not required
   *
   * @generated from rpc ga.config_manager.auth.AuthService.ExternalLogin
   */
  externalLogin: {
    methodKind: "unary";
    input: typeof ExternalLoginRequestSchema;
    output: typeof UserRespSchema;
  },
  /**
   * @generated from rpc ga.config_manager.auth.AuthService.ExternalLogout
   */
  externalLogout: {
    methodKind: "unary";
    input: typeof LogoutReqSchema;
    output: typeof LogoutRespSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_auth_auth, 0);

